import { useSelector } from "react-redux";
import {
    currentRolesSelector,
    currentUserAccountNameSelector,
    currentUserEmailSelector,
} from "../../../redux/slices/auth/selectors";
import { useMemo } from "react";
import { BesuProjectState } from "../../../types/project";
import { useClaimList } from "../../../api/claim";
import { hasProjectAction } from "../../../utils/project";
import {
    hasClaimListAction,
    isClaimVisibleForCurrentUser,
} from "../../../utils/besuClaimList";

const useHasProjectAction = (project: BesuProjectState) => {
    const currentRoles = useSelector(currentRolesSelector);
    const currentUserEmail = useSelector(currentUserEmailSelector);
    const currentUserAccountName = useSelector(currentUserAccountNameSelector);

    const { data: claims } = useClaimList(project.referenceId);

    const hasClaimAction = useMemo(() => {
        return (claims ?? []).some((claim) => {
            return isClaimVisibleForCurrentUser(claim, currentUserAccountName, project.mainContractors) &&
                hasClaimListAction(currentRoles, claim, currentUserEmail);
        });
    }, [claims, currentRoles, currentUserAccountName, currentUserEmail, project.mainContractors]);

    const claimActionNum = useMemo(() => {
        return (claims ?? []).filter((claim) => {
            return isClaimVisibleForCurrentUser(claim, currentUserAccountName, project.mainContractors) &&
                hasClaimListAction(currentRoles, claim, currentUserEmail);
        }).length;
    }, [claims, currentRoles, currentUserAccountName, currentUserEmail, project.mainContractors]);
    return {
        hasProjectAction:
            hasProjectAction(currentRoles, project.status) ||
            hasClaimAction,
        claimActionNum: claimActionNum
    };
};

export default useHasProjectAction;
